import classnames from 'classnames';
import React__default from 'react';
import '../dot/index.js';
import '../stack/index.js';
import '../visually_hidden/index.js';
import { countBadge, kind, size, disabled } from './badge.css.js';
import { Stack } from '../stack/stack.js';
import { Dot } from '../dot/dot.js';
import { VisuallyHidden } from '../visually_hidden/visually_hidden.js';

/**
 * A badge can display a count or text, such as a step number, item count, quick textual information, or a notification. Badges are designed to be non-intrusive, providing information without cluttering the interface, and should always prioritize legibility and context.
 */
const Badge = ({ children, showDot = false, kind: kind$1 = 'neutral', size: size$1 = 'xsmall', disabled: disabled$1 = false, className, ...rest }) => {
    return (React__default.createElement(Stack, { gap: "xsmall", ...rest, className: classnames(countBadge, kind[kind$1], size[size$1], { [disabled]: disabled$1 }, className) },
        showDot && React__default.createElement(Dot, { kind: "highlight", disabled: disabled$1 }),
        React__default.createElement(VisuallyHidden, null, "("),
        children,
        React__default.createElement(VisuallyHidden, null, ")")));
};

export { Badge };
